import React, { createContext, useMemo } from "react";
import { useDetailSidebarContext } from "./DetailSidebarContext";

interface SidebarLocationContextValue {
  isInDetailSidebar: boolean;
}

export const IsInDetailSidebarContext =
  createContext<SidebarLocationContextValue | null>(null);

interface IsInDetailSidebarContextProviderProps {
  children: React.ReactNode;
}

export const IsInDetailSidebarContextProvider: React.FC<
  IsInDetailSidebarContextProviderProps
> = ({ children }) => {
  const { objectId } = useDetailSidebarContext();

  const contextValue: SidebarLocationContextValue = useMemo(
    () => ({
      isInDetailSidebar: !!objectId,
    }),
    [objectId],
  );

  return (
    <IsInDetailSidebarContext.Provider value={contextValue}>
      {children}
    </IsInDetailSidebarContext.Provider>
  );
};
